import { createFileRoute } from '@tanstack/react-router';

import { DocPage } from '@/components/features/documentation/DocPage';
import { getDocComponent } from '@/features/documentation/content-registry';
import { resolveDocPath } from '@/features/documentation/utils/docs-tree-utils';

export const Route = createFileRoute('/_protected/t/$tenantId/docs/')({
  component: DocumentationHome,
});

function DocumentationHome() {
  const contentPath = resolveDocPath('')?.at(-1)?.contentPath;
  const Doc = contentPath ? getDocComponent(contentPath) : undefined;
  if (!Doc) return null;
  return <DocPage Doc={Doc} />;
}
